import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { categories } from "./AccessoriesPage";
import SidebarFilter from "../components/catalog/SidebarFilter";
import ProductCard from "../components/catalog/ProductCard";

const slugify = (text: string) =>
  text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

interface Product {
    _id: string;
    name: string;
    description: string;
    price: string;
    imageUrl: string;
}

const AccessoryDetail: React.FC = () => {
  const { slug } = useParams();
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);

  useEffect(() => {
    if (products) {
        setFilteredProducts(products.filter(p => p.name.toLowerCase().includes(searchQuery.toLowerCase())));
    }
  }, [searchQuery, products]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const category = categories.find(
    (cat) => slug === slugify(cat.name)
  );

  useEffect(() => {
      if(category) {
          fetch(`/api/products?category=${encodeURIComponent(category.name)}`)
            .then(res => res.json())
            .then(data => {
                setProducts(data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
      }
  }, [category]);

  if (!category) {
    return (
      <div className="p-10 text-center text-red-600">
        Kategori bulunamadı.
      </div>
    );
  }



  if (!category) {
    return (
      <div className="p-10 text-center text-red-600">
        Kategori bulunamadı.
      </div>
    );
  }

  return (
    <div className="w-full bg-[#f8f9fa] text-gray-800 font-montserrat min-h-screen">
      {/* Breadcrumb / Title Header */}
      <div className="bg-white border-b py-4 px-6 md:px-12 mb-8">
           <div className="max-w-7xl mx-auto flex items-center text-sm text-gray-500">
               <span>Anasayfa</span> <span className="mx-2">/</span> <span className="text-gray-900 font-semibold">{category.name}</span>
           </div>
      </div>

       <div className="max-w-7xl mx-auto px-6 pb-12">
          <div className="flex flex-col md:flex-row gap-8">
              
              {/* Sidebar */}
              <div className="w-full md:w-64 flex-shrink-0">
                  <SidebarFilter 
                      title={category.name} 
                      categories={[
                          { name: "Tüm Ürünler", active: true, count: products.length },
                          // Potential subcategories could go here
                      ]} 
                      onSearch={setSearchQuery} 
                  />
                  
                  {/* Category Image in Sidebar if desired, or keep it elsewhere */}
                 <div className="mt-6 rounded-lg overflow-hidden border">
                      <img src={category.image.replace(".jpg", "1.jpg")} alt={category.name} className="w-full h-auto" />
                 </div>
              </div>

              {/* Main Content */}
              <div className="flex-1">
                 <h1 className="text-3xl font-bold text-gray-800 mb-6">{category.name}</h1>
                 
                   {/* Sort / Info Bar */}
                   <div className="bg-white p-4 rounded border mb-6 flex justify-between items-center text-sm">
                       <div>Toplan <span className="font-bold">{filteredProducts.length}</span> ürün</div>
                       <select className="border rounded p-1">
                           <option>Önerilen sıralama</option>
                           <option>Fiyata göre artan</option>
                           <option>Fiyata göre azalan</option>
                       </select>
                   </div>

                   {loading ? (
                        <div className="text-center py-20">Yükleniyor...</div>
                   ) : filteredProducts.length === 0 ? (
                        <div className="text-center py-20 bg-white rounded border">
                             Bu kategoride henüz ürün bulunamadı.
                             {category.items.length > 0 && (
                                 <div className="mt-4 text-sm text-gray-500">
                                     Aradığınız ürün grupları: {category.items.join(", ")}
                                 </div>
                             )}
                        </div>
                   ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {filteredProducts.map(product => (
                                <ProductCard 
                                    key={product._id}
                                    id={product._id} // Need to ensure products route works with ID
                                    title={product.name}
                                    price={product.price}
                                    image={product.imageUrl}
                                    linkPrefix="/urunler/aksesuar" 
                                    discountPercent={Math.random() > 0.7 ? 15 : undefined} 
                                />
                            ))}
                        </div>
                   )}
              </div>
          </div>
       </div>
    </div>
  );
};

export default AccessoryDetail;
